app
  .controller("SubscriptionDetailsController", [
    "$scope",
    "SubscriptionFactory",
    "$location",
    function ($scope, SubscriptionFactory, $location) {
      $scope.isLoading = true;
      $scope.isOnSubscriptionPage = false;

      const path = $location.path();
      if (path.includes("subscribe")) {
        $scope.isOnSubscriptionPage = true;
      }

      SubscriptionFactory.getSubscriptionDetails(fullSite.micrositeID).then(
        function (response) {
          $scope.isLoading = false;
          $scope.subscriptionDetails = response;
        }
      );

      $scope.getPaymentIntent = function () {
        $scope.isLoading = true;
        $scope.payload.getPaymentIntent();
      };
    },
  ])
  .directive("subscriptionDetails", [
    function () {
      return {
        restrict: "AE",
        transclude: true,
        scope: true,
        templateUrl: "template/elements/subscriptionDetails.html",
      };
    },
  ]);
